<template>
  <div>
    <div class="compair-layout--box">
      <!-- header / filter -->
      <div class="compair-layout--box-header">
        <vs-row vs-w="12">
          <vs-col vs-sm="12" vs-lg="12" class="p-2">
            <div>
              <!-- qrcode name -->
              <DataInput
                v-model="qrCodeInput.name"
                type="text"
                label="Name *"
                name="name"
                placeholder="Name"
                class="mb-4"
              />
              <vs-row>
                <vs-col vs-sm="12" vs-lg="12">
                  <data-input
                    v-model="useCustomUrl"
                    label="Manuelle Url"
                    name="useCustomUrl"
                    type="bool"
                    class="mb-4"
                  />
                </vs-col>
                <vs-col vs-sm="12" vs-lg="12">
                  <!-- base_url -->
                  <div v-show="useCustomUrl">
                    <DataInput
                      v-model="qrCodeInput.base_url"
                      type="text"
                      label="URL *"
                      placeholder="URL"
                      name="base_url"
                      class="mb-4"
                    />
                    <DataInput
                      v-model="qrCodeInput.user_group_id"
                      type="model"
                      label="Benutzergruppe"
                      placeholder="Benutzergruppe"
                      name="group"
                      gql-query="userGroups"
                      allow-null
                      class="mb-4"
                    />
                  </div>
                  <!-- or vacancy -->
                  <DataInput
                    v-show="!useCustomUrl"
                    v-model="qrCodeInput.vacancy_id"
                    type="model"
                    placeholder="Stelle"
                    name="vacancy"
                    label="Stelle"
                    model-label="title"
                    gql-query="vacancyPage"
                    gql-filter-type="objectFilter"
                    object-filter-attribute="searchQuery"
                    allow-null
                    class="mb-4"
                  />
                </vs-col>
              </vs-row>
              <!-- base_url -->
              <!-- <DataInput
                v-model="qrCodeInput.base_url"
                type="text"
                label="URL *"
                name="base_url"
                class="mb-4"
              /> -->
              <!-- ausprägung/druckgegenstand -->
              <DataInput
                v-model="qrCodeInput.variant_id"
                type="model"
                label="Ausprägung *"
                name="qrCodeVariants"
                gql-query="qrCodeVariants"
                :gql-query-attributes="`page: 1, search: $search`"
                allow-null
                class="mb-4"
              />
              <!-- kampagne -->
              <DataInput
                v-model="qrCodeInput.ad_campaign_id"
                type="model"
                name="campaign"
                label="Kampagne"
                model-label="name"
                gql-query="adCampaigns"
                gql-filter-type="objectFilter"
                object-filter-attribute="search"
                allow-null
              />
              <qrcode
                v-show="qr_url"
                id="qrcode-component"
                :value="`${qr_url}`"
                :options="{ width: 4000 }"
                style="display:none;"
              />
            </div>
          </vs-col>
          <vs-col vs-sm="12" vs-lg="12" class="pr-2 pt-4 text-right">
            <vs-button @click="submit()"> Generieren & Downloaden </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";

export default {
  components: {
    DataInput
  },
  props: {},
  data: () => ({
    useCustomUrl: true,
    qr_url: null,
    vacancy: null,
    qrCodeInput: {
      name: null,
      ad_campaign_id: null,
      user_group_id: null,
      variant_id: null,
      base_url: null,
      vacancy_id: null
    }
  }),
  computed: {
    slugifiedUrl() {
      let str = this.vacancy.title;
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "ßàáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "saaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes

      str = `https://www.select-gmbh.de/jobs/job/detail/${str}/${this.vacancy.number}`;

      return str;
    }
  },
  watch: {
    useCustomUrl: {
      deep: true,
      handler() {
        this.vacancy = null;
        this.resetForm();
        // this.qrCodeInput.vacancy_id = null;
        // this.qrCodeInput.user_group_id = null;
        // this.qrCodeInput.base_url = null;
      }
    },
    "qrCodeInput.vacancy_id": {
      deep: true,
      handler: function(val) {
        if (!val) {
          this.vacancy = null;
        } else {
          this.getVacancy();
        }
      }
    }
  },
  mounted() {},
  methods: {
    getVacancy() {
      this.$apollo
        .query({
          query: gql`
            query Vacancy($id: ID!) {
              vacancy(id: $id) {
                id
                title
                number
                project {
                  id
                  userGroup {
                    id
                  }
                }
              }
            }
          `,
          variables: {
            id: this.qrCodeInput.vacancy_id
          }
        })
        .then(response => {
          // set vacancy
          this.vacancy = response.data.vacancy;
          // fill qrcodeinput with vacancy data
          this.qrCodeInput.base_url = this.slugifiedUrl;
          this.qrCodeInput.user_group_id = this.vacancy.project.userGroup.id;
          this.qrCodeInput.vacancy_id = this.vacancy.id;
        });
    },
    async submit() {
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation QrCodeCreate($input: QrCodeInput!) {
              qrCodeCreate(input: $input) {
                id
                name
                base_url
                qr_url
                user_group_id
                variant_id
                ad_campaign_id
              }
            }
          `,
          variables: {
            input: this.qrCodeInput
          }
        })
        .then(({ data }) => {
          this.$emit("update");
          // download new qrcode
          this.qr_url = data.qrCodeCreate.qr_url;
          // use next tick, or it downloads faster then the qr get updated...
          this.$nextTick().then(() => {
            // download qr
            this.downloadQr(data);
            // reset form
            this.resetForm();
            // reset qr_url
            this.qr_url = null;
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    downloadQr(data) {
      var link = document.createElement("a");
      link.download = data.qrCodeCreate.name + ".png";
      link.href = document.getElementById("qrcode-component").toDataURL();
      link.click();
    },
    resetForm() {
      this.qrCodeInput = {
        name: null,
        ad_campaign_id: null,
        user_group_id: null,
        variant_id: null,
        base_url: null,
        vacancy_id: null
      };
    }
  }
};
</script>

<style scoped>
.qr-download-col {
  text-align: end;
}
td {
  padding: 1rem;
  /* padding-bottom: 0; */
  opacity: 0.8;
}
tr + tr {
  border-top: 1px solid lightgray;
}
th {
  padding: 1rem;
  padding-bottom: 0;
  font-size: 1.125rem;
  font-weight: 400;
}
h4 {
  margin-left: 0.5rem;
}
table {
  border-collapse: collapse;
  width: 100%;
}
</style>
